import { injectable } from 'inversify';
import { GetBookingsFilter, GetStopOrderParams, IBookingService } from './IBookingService';
import { ApiResponse, BookingDto, CreateBookingDto, StopOrderDto } from '@/types/webapi';
import { format } from 'date-fns';
import ServiceOptions from './ServiceOptions';
import { ApiService } from './ApiService';

@injectable()
export class BookingService extends ApiService implements IBookingService {
    getAllBookings(options?: ServiceOptions): Promise<BookingDto[]> {
        return this.getBookings(undefined, options);
    }

    getBookings(params?: GetBookingsFilter, options?: ServiceOptions): Promise<BookingDto[]> {
        return new Promise<BookingDto[]>((resolve, reject) => {
            this.axios
                .get<ApiResponse<BookingDto[]>>('/api/v1.0/bookings/my', { params, signal: options?.signal })
                .then(response => resolve(response.data.data))
                .catch(reject);
        });
    }

    getBooking(id: string): Promise<BookingDto> {
        return new Promise<BookingDto>((resolve, reject) => {
            this.axios
                .get<ApiResponse<BookingDto>>(`/api/v1.0/bookings/${id}`)
                .then(response => resolve(response.data.data))
                .catch(reject);
        });
    }

    createBooking(params: CreateBookingDto): Promise<BookingDto> {
        return new Promise<BookingDto>((resolve, reject) => {
            this.axios
                .post<ApiResponse<BookingDto>>('/api/v1.0/bookings', params)
                .then(response => resolve(response.data.data))
                .catch(reject);
        });
    }

    cancelBooking(id: string): Promise<BookingDto> {
        return new Promise((resolve, reject) => {
            this.axios
                .put<ApiResponse<BookingDto>>(`/api/v1.0/bookings/${id}/cancel`)
                .then(response => resolve(response.data.data))
                .catch(reject);
        });
    }

    getStopOrder(params: GetStopOrderParams, options?: ServiceOptions): Promise<StopOrderDto | undefined> {
        return new Promise((resolve, reject) => {
            const { activeDate, serviceJourneyRef, stopSequence } = params;

            this.axios
                .get<ApiResponse<StopOrderDto>>(
                    `/api/v1.0/stop-orders/${format(activeDate, 'yyyy-MM-dd')}/${serviceJourneyRef}/${stopSequence}`,
                    {
                        signal: options?.signal
                    }
                )
                .then(response => resolve(response.data.data || undefined))
                .catch(reject);
        });
    }
}
